
import React from 'react';
import { useLocation } from 'react-router-dom';
import Page from './Page';
import UpdatedPlayerPageTemplate from '../templates/UpdatedPlayerPageTemplate';

export default function UpdatedPlayerProfile () {
  const location = useLocation();
  const printed = location.pathname.endsWith('/pdf');

  return (
    <Page
      printed={printed}
      title='Player'
    >
      <UpdatedPlayerPageTemplate printed={printed} />
    </Page>
  );
}
